import styled from 'styled-components';
import PropTypes from 'prop-types';
import { spacingMixin } from '@zillow/constellation';
import customPropTypes from '../../utils/custom-prop-types.js';
import { videoMixin } from '../../mixins/components/VideoMixin.js';

var ResponsiveVideo = /*#__PURE__*/styled.video.withConfig({
  componentId: "sc-14c8lrd-0"
})(["", " ", ""], spacingMixin, videoMixin);
ResponsiveVideo.propTypes = {
  src: PropTypes.string.isRequired,
  poster: PropTypes.string.isRequired,
  controls: PropTypes.bool.isRequired,
  ratio: PropTypes.string.isRequired,
  margin: customPropTypes.inlineMediaQuery(PropTypes.shape({
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginLeft: PropTypes.string,
    marginBottom: PropTypes.string
  }))
};
ResponsiveVideo.defaultProps = {};
/** @component */
var ResponsiveVideo$1 = ResponsiveVideo;

export { ResponsiveVideo$1 as default };
